import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import MenuItemCard from "./MenuItemCard";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SendIcon from "@mui/icons-material/Send";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import {
  RUTA_COMUNICACIONES_REPORTE_DIARIO,
  RUTA_COMUNICACIONES_CORREOS_MASIVOS,
} from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-8 col-xxl-6">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mb-2 p-3">
              {puedeAccederRuta(usuario, RUTA_COMUNICACIONES_REPORTE_DIARIO) && (
                <CardCol>
                  <MenuItemCard
                    Icono={SummarizeIcon}
                    ruta={RUTA_COMUNICACIONES_REPORTE_DIARIO}
                    titulo="Reporte diario"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_COMUNICACIONES_CORREOS_MASIVOS) && (
                <CardCol>
                  <MenuItemCard
                    Icono={SendIcon}
                    ruta={RUTA_COMUNICACIONES_CORREOS_MASIVOS}
                    titulo="Correos masivos"
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={6} sm={6} className="mb-2">
      {children}
    </Col>
  );
};

export default CardSection;
